export const validateConfigurations = (cfrConfiguration, mttrConfiguration) => {
  if (
    cfrConfiguration?.incident_strategy_config &&
    !cfrConfiguration?.incident_strategy_config?.config?.value
  ) {
    return false;
  }
  if (
    mttrConfiguration?.incident_strategy_config &&
    (!mttrConfiguration?.incident_strategy_config?.config?.from ||
      !mttrConfiguration?.incident_strategy_config?.config?.to)
  ) {
    return false;
  }
  return true;
};
